// extracted by mini-css-extract-plugin
export default {"imageWrapper":"OU-z","hovered":"PU-z","hoverImage":"QU-z","mainImage":"RU-z","imageNoBackground":"SU-z","fullSizeImage":"TU-z"};